import React from 'react';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import imgHeaderBg from '../../img/block-1-bg.png';
// translate
import messages from './messages';

function RewardsPage(props) {
  const { intl } = props;
  return (
    <div>
      <div
        className="container-fluid block-4"
        style={{ backgroundImage: `url('${imgHeaderBg}')` }}
      >
        <div className="row">
          <div className="container">
            <div className="row">
              <p className="text-header">
                <FormattedHTMLMessage {...messages.header} />
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid block-5">
        <div className="row">
          <div className="container">
            <div className="row">
              <div className="col-md-10 col-md-push-1 table-wrap">
                <div className="table-wrap-inner">
                  <table className="table-1">
                    <thead>
                      <tr>
                        <td style={{ textAlign: 'center' }}>
                          <strong>10%</strong>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          <strong>20%</strong>
                        </td>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td className="member-sevices">
                          {intl.formatMessage(messages.table1Td1)}
                        </td>
                        <td className="periodicity">
                          {intl.formatMessage(messages.table1Td2)}
                        </td>
                      </tr>
                      <tr>
                        <td className="member-sevices">
                          {intl.formatMessage(messages.table1Td3)}
                        </td>
                        <td className="periodicity">
                          {intl.formatMessage(messages.table1Td4)}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="3">
                          <FormattedHTMLMessage {...messages.table1Td5} />
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <p className="text-header">
                    <strong>{intl.formatMessage(messages.exceptions)}</strong>
                  </p>

                  <div className="columns-wrap">
                    <div className="col-md-6">
                      <div className="row">
                        <p className="text">
                          {intl.formatMessage(messages.exceptionsText1)}
                        </p>
                        <p className="text">
                          {intl.formatMessage(messages.exceptionsText2)}
                        </p>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="row">
                        <p className="text">
                          {intl.formatMessage(messages.exceptionsText3)}
                        </p>
                        <p className="text">
                          {intl.formatMessage(messages.exceptionsText4)}
                        </p>
                      </div>
                    </div>
                  </div>

                  <p className="text-header">
                    <strong>{intl.formatMessage(messages.attention)}</strong>
                  </p>
                  <p className="text text-attention col-md-10 col-md-push-1">
                    {intl.formatMessage(messages.attentionText)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

RewardsPage.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(RewardsPage);



// WEBPACK FOOTER //
// ./src/pages/RewardsPage/index.js